/**
 * Custom HTML home (ADR 0007) helpers for the Studio. Pure. The server is the
 * boundary: these only shape what it answers for display.
 */

/** Server problems ({ path: 'html:<line>:<column>', message, code } or engine { line, column }) as sorted rows. */
export function problemRows(list = []) {
  return (list || [])
    .map((p) => {
      const m = /^html:(\d+):(\d+)$/.exec(String(p.path || ''));
      const line = p.line != null ? Number(p.line) : m ? Number(m[1]) : null;
      const column = p.column != null ? Number(p.column) : m ? Number(m[2]) : null;
      return { line, column, code: p.code || '', message: String(p.message || '') };
    })
    .sort((a, b) => (a.line || 0) - (b.line || 0) || (a.column || 0) - (b.column || 0));
}

/** "Line 3, column 7" (or nothing when the problem has no position). */
export const positionLabel = (row) => (row.line ? `Line ${row.line}${row.column ? `, column ${row.column}` : ''}` : '');

/** The error rows from a failed request (422 details), or a single row with the message. */
export function failureRows(ex) {
  const body = (ex && ex.response && ex.response.data) || {};
  if (Array.isArray(body.details) && body.details.length) return problemRows(body.details);
  return [{ line: null, column: null, code: body.code || '', message: body.error || (ex && ex.message) || 'Something went wrong.' }];
}

/** Where a store's custom home stands: off (nothing live), live, or live with unpublished changes. */
export function homeState({ draft, live } = {}) {
  if (live && draft) return { key: 'changes', label: 'Live, with unpublished changes', variant: 'warning' };
  if (live) return { key: 'live', label: `Live (version ${live.version})`, variant: 'success' };
  if (draft) return { key: 'draft', label: 'Draft, not live', variant: 'default' };
  return { key: 'off', label: 'Off: shoppers see the standard home', variant: 'default' };
}

export const MAX_TEMPLATE_BYTES = 256 * 1024;

/** UTF-8 size of the template, as the server counts it. */
export const byteSize = (text) => new TextEncoder().encode(String(text || '')).length;
